const formatPreciseNumber = (number: number | string) => {
    const num = Number(number);
    const decimals = num.toString().split('.')[1] ?? '';
    const firstNonZeroIndex = decimals.split('').findIndex(decimal => decimal !== '0');
    const precision = firstNonZeroIndex + 4;

    return Number(Number(number)).toLocaleString(undefined, {
        notation: 'standard',
        minimumFractionDigits: precision,
    });
};

export { formatPreciseNumber };
